import { render, staticRenderFns } from "./ReportByResidents.vue?vue&type=template&id=672be092"
import script from "./ReportByResidents.vue?vue&type=script&lang=ts"
export * from "./ReportByResidents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports